import { Grid } from 'ui-toolkit';
import React from 'react';
import { PaymentPercentageLabel } from './PaymentPercentageLabel';
import { SettlementPercentageDisplayAndForm } from './SettlementPercentageDisplayAndForm';
import { defaultPolicyPremiumDetailsData } from '../../../../../../types/order/title/IPolicyPremiumDetailsResponse';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../../../../types/shared/UUID';
import { useGetPolicyPremiumDetailsQuery } from '../../../../../../API/order/title/PolicyPremiumDetailsAPI';
import { Show } from '../../../../../shared/Show';

// Per Phillippa, the defaultLenderSellerPaidPercent (which does not exist on IPolicyPremiumDetailsData) will always be 0%.
export const PercentageFormsContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();

  const { data: { cashPurchase, defaultOwnerSellerPaidPercent } = defaultPolicyPremiumDetailsData } =
    useGetPolicyPremiumDetailsQuery(orderId);

  return (
    <Grid columnCount={2} alignItems={'center'}>
      <PaymentPercentageLabel isOwner={true} percent={defaultOwnerSellerPaidPercent} />
      <SettlementPercentageDisplayAndForm isOwner={true} />
      <Show when={!cashPurchase}>
        <PaymentPercentageLabel isOwner={false} percent={0} />
        <SettlementPercentageDisplayAndForm isOwner={false} />
      </Show>
    </Grid>
  );
};
